import React from "react";
import { Icon } from "@iconify/react";
import PropTypes from "prop-types";
import ModalDialog from "./modal_dialog";
import CloseIcon from "./close_icon";

function ErrorModalDialog({
  onClose,
  headerText,
  messageText,
  messages,
  submessageText,
  renderActions,
  errorClassName,
}) {
  function handleOnCloseClick(e) {
    e.preventDefault();
    if (onClose) {
      onClose();
    }
  }
  return (
    <ModalDialog
      modalDialogClassName={`component-error-modal-dialog ${errorClassName}`}
    >
      <div>
        <a onClick={handleOnCloseClick}>
          <CloseIcon className="close-button" />
        </a>

        <div className="icon-and-content">
          <div className="icon-container">
            <Icon icon="ant-design:exclamation-circle-outlined" />
          </div>
          <div className="content-container">
            <div className="header">{headerText}</div>
            <div className="message">{messageText}</div>
            {messages && (
              <ul>
                {messages.map((message, index) => (
                  <li key={index}>{message}</li>
                ))}
              </ul>
            )}
            <div className="sub-message">{submessageText}</div>
            <div className="actions">{renderActions && renderActions()}</div>
          </div>
        </div>
      </div>
    </ModalDialog>
  );
}

ErrorModalDialog.defaultProps = {
  errorClassName: "",
  headerText: "",
  messageText: "",
  submessageText: "",
};

ErrorModalDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  errorClassName: PropTypes.string,
  headerText: PropTypes.string,
  messageText: PropTypes.string,
  messages: PropTypes.array,
  submessageText: PropTypes.string,
  renderActions: PropTypes.func.isRequired,
};

export default ErrorModalDialog;
